import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTelegram = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.875 13.625 15 19.25l4.25-14.5L4.75 10zm0 0 2.375-1.875"
    />
  </svg>
);
export default SvgTelegram;
